module.exports = require('./lib/_stream_writable.js');



//////////////////
// WEBPACK FOOTER
// D:/TMB/sr-git-v1/TMB.UI/node_modules/stream-browserify/node_modules/readable-stream/writable-browser.js
// module id = ../../../../stream-browserify/node_modules/readable-stream/writable-browser.js
// module chunks = vendor